import {Pipe, PipeTransform} from '@angular/core';
import {Permission, ROLE_LABELS, RoleType} from "@app/_model";
import {Logger} from "@app/logger";

@Pipe({
  name: 'role',
  standalone: true
})
export class RolePipe implements PipeTransform {
  public transform(role: RoleType): string {
    if (!role) {
      return '';
    } else {
      return ROLE_LABELS[role];
    }
  }
}

@Pipe({
  name: 'roles',
  standalone: true
})
export class RolesPipe implements PipeTransform {
  public transform(roles: RoleType[]): string {
    if (!roles) {
      return '';
    } else {
      return roles.map(role => ROLE_LABELS[role]).join(", ");
    }
  }
}

@Pipe({
  name: 'permissions',
  standalone: true
})
export class PermissionsPipe implements PipeTransform {
  private readonly log = new Logger();
  public transform(permissions: Permission[]): string {
    if (!permissions) {
      return '';
    } else {
      this.log.trace(permissions);
      return permissions.filter(permission => permission.permitted).map(permission => permission.permission).map(permission => ROLE_LABELS[permission]).join(", ");
    }
  }
}
